// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".consentAdvertising[data-v-2f436dd4]{align-items:center;color:#80869a;display:inline-flex;font-size:12px;font-weight:400;line-height:16px;margin-top:20px}.consentAdvertising__checkbox[data-v-2f436dd4]{margin-right:13px}.consentAdvertising__text[data-v-2f436dd4]{color:#80869a;font-size:15px;font-weight:500;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
